import Vue from 'vue'
import BootsrapVue from 'bootstrap-vue';
import moment from 'moment';
import VueCompositionAPI from '@vue/composition-api'
import VueMq from 'vue-mq';
import VueSwal from 'vue-swal';
import {
  ValidationObserver,
  ValidationProvider,
  extend,
} from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';

import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'

// import assets styles
require('@/assets/scss/style.scss')

// Install VeeValidate components globally
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

// Install VeeValidate rules and localization
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

// vue mq
Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    sm: 450,
    md: 1250,
    lg: Infinity,
  },
  defaultBreakpoint: 'sm',
})

Vue.use(VueSwal);

// BSV Plugin Registration
Vue.use(BootsrapVue)

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

Vue.filter('formatDate', value => {
  if (!value) return '';
  return moment(String(value)).format('DD/MM/YYYY');
});

Vue.filter('formatDateTime', value => {
  if (!value) return '';
  return moment(String(value)).format('DD/MM/YYYY HH:mm');
});

Vue.filter('capEachWord', value => {
  if (!value) return '';
  return value
    .toLowerCase()
    .split(' ')
    .map(s => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ');
});

Vue.filter('boolToYes', value => (value ? 'Yes' : 'No'));

Vue.filter('formatDateAge', value => {
  if (!value) return '';
  return moment(new Date()).diff(value, 'years');
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
